import { Selectors } from "@grandvisionhq/auth";
import { useSelector } from "@grandvisionhq/state";
import { shouldCreateAccount } from "../../../../selectors.js";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useShouldCreateAccount = () => {
  const shouldCreateAccount$1 = useSelector(shouldCreateAccount);
  const isLoggedIn = useSelector(Selectors.isLoggedIn);
  const { account } = useCheckoutSettings();
  if (isLoggedIn) {
    return false;
  } else if (!isLoggedIn && account?.createAccountRequired) {
    return true;
  } else if (shouldCreateAccount$1 !== void 0) {
    return shouldCreateAccount$1;
  } else {
    return false;
  }
};
export {
  useShouldCreateAccount
};
//# sourceMappingURL=use-should-create-account.js.map
